<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">All users</h1>

    <table class="w-full whitespace-nowrap">
      <tr class="text-left font-bold">
        <th class="pb-4 pt-6 px-6">Name</th>
        <th class="pb-4 pt-6 px-6">Email</th>
        <th class="pb-4 pt-6 px-6">Phone</th>
      </tr>
      <tr v-for="user in users" :key="user.id">
        <td class="pb-4 pt-6 px-6">{{ user.first_name }} {{ user.last_name }}</td>
        <td class="pb-4 pt-6 px-6">{{ user.email }}</td>
        <td class="pb-4 pt-6 px-6">{{ user.created_at }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
  props: {
    users: Array,
  },
}
</script>